<div class="wrapper no-padding-mobile">
  <mat-card-content class="control-card">
    <div class="domain-controls">
      
        <mat-form-field>
          <mat-label>Dominio</mat-label>
          <input matInput 
            [formControl]="domainControl" placeholder="Dominio" required
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
          >
        </mat-form-field>
        <button mat-raised-button class="secondary" (click)="loadDomain()" style="margin-bottom: 10px" [disabled]="loading()" (submit)="loadDomain()">Conectarse</button>
    </div>
  </mat-card-content>
</div>
